<ng-select
  appNgSelectA11y
  [ngSelectA11yId]="effectiveInputId"
  [ngSelectA11yLabelledBy]="labelElementId"
  [ngSelectA11yDescribedBy]="describedBy"
  [ngSelectA11yInvalid]="ariaInvalid"
  [appNgSelectA11y]="ariaLabel || ('SEARCH' | translate)"
  [clearable]="true"
  [items]="items"
  [(ngModel)]="selectedItem"
  [compareWith]="compareWith"
  [notFoundText]="'NO_ITEMS_FOUND' | translate"
  [bindLabel]="'label'"
  [bindValue]="'value'"
  [loading]="isLoading"
  [placeholder]="'SEARCH' | translate"
  [appendTo]="'body'"
  [inputAttrs]="effectiveInputAttrs"
  (change)="onChange($event)"
  (open)="onOpen()"
  (search)="onSearch($event)"
  [disabled]="disabled"
  [multiple]="multiple"
  class="p-0"
>
  <ng-template ng-label-tmp let-item="item">
    <!-- Multiple off -->
    <ng-container *ngIf="!multiple; else multipleTemplate">
      <span *ngIf="item.extraLabels.firstLabel">{{ item.extraLabels.firstLabel }}</span>
      <span *ngIf="item.extraLabels.secondLabel">{{ item.extraLabels.secondLabel }}</span>
    </ng-container>

    <!-- Multiple on -->
    <ng-template #multipleTemplate>
      <button type="button" class="ng-value-icon left border-0 bg-transparent p-0" (click)="$event.stopPropagation(); onRemoveItem(item)" [attr.aria-label]="'REMOVE' | translate">
        <span aria-hidden="true">×</span>
      </button>
      <span *ngIf="item.extraLabels.firstLabel">{{ item.extraLabels.firstLabel }}</span>
    </ng-template>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index">
    <div class="option-title option-line-height">
      <span *ngIf="item.extraLabels.firstLabel">{{ item.extraLabels.firstLabel }}</span>
      <span *ngIf="item.extraLabels.secondLabel">{{ item.extraLabels.secondLabel }}</span>
    </div>
    <small class="option-meta option-line-height" *ngIf="item.extraLabels.thirdLabel || item.extraLabels.fourthLabel">
      {{ item.extraLabels.thirdLabel ?? item.extraLabels.fourthLabel }}
    </small>
  </ng-template>
  <!-- WCAG 4.1.3 — role="alert" announces "no items found" to screen readers (Deque status-msg-not-auto-announced) -->
  <ng-template ng-notfound-tmp>
    <div class="ng-option disabled" role="alert" aria-atomic="true">{{ 'NO_ITEMS_FOUND' | translate }}</div>
  </ng-template>
</ng-select>
